import Skeleton from '@mui/material/Skeleton';
import type React from 'react';
import MediaRouterComponent from '../../AkomiMediaCard/MediaRouterComponent';
import AkomiCollectionMedia from '../../Collection/AkomiCollectionMedia';
import EmptyCollectionThumbnail from '../../Collection/EmptyCollectionThumbnail';
import { useListViewRowContext } from '../ListViewRowContext';

const ThumbnailCell: React.FC = () => {
  const { loading, rowType, itemId, collection, density, onShowPreview } = useListViewRowContext();

  if (loading) {
    return (
      <Skeleton
        variant="rectangular"
        width={density.thumbWidth}
        height={density.thumbHeight}
        animation="wave"
        sx={{ borderRadius: 0.5 }}
      />
    );
  }

  if (rowType === 'asset' && itemId) {
    return (
      // biome-ignore lint/a11y/useKeyWithClickEvents: keyboard navigation handled at table row level
      // biome-ignore lint/a11y/noStaticElementInteractions: keyboard navigation handled at table row level
      <div
        onClick={() => onShowPreview?.()}
        style={{
          cursor: 'pointer',
          width: density.thumbWidth,
          height: density.thumbHeight,
          overflow: 'hidden',
          borderRadius: 2,
        }}
      >
        <MediaRouterComponent
          itemId={itemId}
          shared={false}
          setPlayer={() => {}}
          videoJsProps={{ options: { controls: false } }}
        />
      </div>
    );
  }

  if (rowType === 'collection') {
    const firstItem = collection?.items?.[0];
    const hasKnownItems = Array.isArray(collection?.items);
    const isEmptyCollection = hasKnownItems && (collection?.items?.length ?? 0) === 0;

    return (
      <div
        style={{
          width: density.thumbWidth,
          height: density.thumbHeight,
          overflow: 'hidden',
          borderRadius: 2,
        }}
      >
        {isEmptyCollection ? (
          <EmptyCollectionThumbnail variant="compact" />
        ) : (
          <AkomiCollectionMedia
            itemObjectId={firstItem?.objectId}
            itemId={firstItem?.contentObject?.id}
            onImageClick={() => onShowPreview?.()}
          />
        )}
      </div>
    );
  }

  return null;
};

export default ThumbnailCell;
